import WindsorApi from '../api/WindsorApi';
import { decorate, observable } from 'mobx';

class EnvironmentStore {
    private windsorApi: WindsorApi;
    private environmentMapByName: any = {};
    private environmentMapByAccountId: any = {};

    public environments: any[] = null;
    
    constructor(windsorApi: WindsorApi) {
        this.windsorApi = windsorApi;
        this._loadEnvironments();
    }

    getEnvironmentByName(name: string) {
        return this.environmentMapByName[name];
    }

    getEnvironmentByAccountId(accountId: string) {
        return this.environmentMapByAccountId[accountId];
    }

    _loadEnvironments() {
        this.windsorApi.getEnvironments().then(environments => {
            environments.forEach(env => {
                this.environmentMapByName[env.EnvironmentName] = env;
                this.environmentMapByAccountId[env.AccountID] = env;
            });
            this.environments = environments;
        });
    }
}

decorate(EnvironmentStore, {
    environments: observable
});

export default EnvironmentStore;